import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutComponent } from './Component/about/about.component';
import { TermsComponent } from './Component/terms/terms.component';
import { FaqComponent } from './Component/faq/faq.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrivacyPolicyComponent } from './Component/privacy-policy/privacy-policy.component';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from '../app-routing.module';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';

@NgModule({
  declarations: [AboutComponent, TermsComponent, FaqComponent, PrivacyPolicyComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    AccordionModule.forRoot(),
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgcCookieConsentModule
    
  ]
})
export class StaticContentModule { }
